import React from 'react';
import { MapPinOff, AlertCircle, ArrowLeft, MessageCircle } from 'lucide-react';

const MapaDesativado = () => {
  // Cores baseadas na identidade visual do EVOMAP
  const colors = {
    brandPurple: '#9d50ff',
    bgDark: '#000033',
    textGray: '#a0aec0',
    white: '#ffffff'
  };

  const styles = {
    container: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: colors.bgDark,
      padding: "2rem",
      textAlign: "center",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      position: "relative",
      overflow: "hidden"
    },
    card: {
      zIndex: 2,
      maxWidth: "500px",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    logoContainer: {
      marginBottom: "3rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    logoText: {
      fontSize: "2.5rem",
      fontWeight: "800",
      color: colors.white,
      letterSpacing: "-1px",
      marginTop: "10px"
    },
    brandSpan: {
      color: colors.brandPurple
    },
    iconCircle: {
      backgroundColor: "rgba(157, 80, 255, 0.15)",
      padding: "2rem",
      borderRadius: "50%",
      border: `1px solid rgba(157, 80, 255, 0.3)`,
      position: "relative",
      marginBottom: "1.5rem"
    },
    alertBadge: {
      position: "absolute",
      top: "5px",
      right: "5px",
      backgroundColor: "#ef4444",
      borderRadius: "50%",
      padding: "4px",
      border: `3px solid ${colors.bgDark}`,
      display: "flex"
    },
    title: {
      fontSize: "1.8rem",
      fontWeight: "700",
      color: colors.white,
      marginBottom: "1rem"
    },
    description: {
      color: colors.textGray,
      fontSize: "1.1rem",
      lineHeight: "1.6",
      marginBottom: "2.5rem"
    },
    buttonPrimary: {
      backgroundColor: colors.brandPurple,
      color: colors.white,
      padding: "0.9rem 2rem",
      borderRadius: "12px",
      border: "none",
      fontWeight: "600",
      fontSize: "1rem",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      width: "100%",
      justifyContent: "center",
      marginBottom: "1rem",
      transition: "transform 0.2s"
    },
    buttonSecondary: {
      backgroundColor: "transparent",
      color: colors.textGray,
      padding: "0.9rem 2rem",
      borderRadius: "12px",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      fontWeight: "500",
      fontSize: "1rem",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      width: "100%",
      justifyContent: "center"
    },
    footer: {
      marginTop: "4rem",
      color: colors.textGray,
      fontSize: "0.75rem",
      letterSpacing: "1px",
      opacity: 0.6
    },
    glow: {
      position: "absolute",
      width: "400px",
      height: "400px",
      borderRadius: "50%",
      background: "radial-gradient(circle, rgba(157, 80, 255, 0.08) 0%, rgba(0, 0, 51, 0) 70%)",
      zIndex: 1
    }
  };

  return (
    <div style={styles.container}>
      <div style={{ ...styles.glow, top: "-10%", right: "-10%" }}></div>
      <div style={{ ...styles.glow, bottom: "-10%", left: "-10%" }}></div>

      <div style={styles.card}>
        <div style={styles.iconCircle}>
          <MapPinOff size={60} color={colors.brandPurple} />
          <div style={styles.alertBadge}>
            <AlertCircle size={16} color="white" />
          </div>
        </div>

        <h2 style={styles.title}>Mapa Indisponível</h2>
        <p style={styles.description}>
          Esta funcionalidade foi temporariamente desativada pela organização ou você não possui permissão para acessá-la através deste link.
        </p>

      </div>
    </div>
  );
};

export default MapaDesativado;